import React from 'react'
import ReactDOM from 'react-dom'
import { SimulationEditor } from './SimulationEditor'
import { AISimulationGeneratorPanel } from './AISimulationGeneratorPanel'

export const startSimulationEditor = (containerId, options) => {
  const container = document.getElementById(containerId)
  if (!container) {
    console.error(`SimulationEditor: container "#${containerId}" not found`)
    return
  }

  ReactDOM.render(
    <SimulationEditor
      pluginSelectId={options.pluginSelectId}
      configTextareaId={options.configTextareaId}
      tasksTextareaId={options.tasksTextareaId}
    />,
    container
  )
}

export const startAISimulationGenerator = (containerId, options) => {
  const container = document.getElementById(containerId)
  if (!container) {
    console.error(`AISimulationGenerator: container "#${containerId}" not found`)
    return
  }

  ReactDOM.render(
    <AISimulationGeneratorPanel coursenum={options.coursenum} />,
    container
  )
}
